/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Pipelines_ItemsInputs */

const cs_pipelines_items = /** @type {(inputs: Pipelines_ItemsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} položek`)
};

const en_pipelines_items = /** @type {(inputs: Pipelines_ItemsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} items`)
};

/**
* | output |
* | --- |
* | "{count} items" |
*
* @param {Pipelines_ItemsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_items = /** @type {((inputs: Pipelines_ItemsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_ItemsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_items(inputs)
	return cs_pipelines_items(inputs)
});